import { Flex } from "@chakra-ui/react";
import { HEADER_GROUP, useBookingRecoilValue, useNewNavigate } from "@shared/client";
import { useState } from "react";
import { CustomBox, CustomButton, CustomLocalNavBar, CustomText, CustomTitle, Wrapper } from "./globalNavBar.style";
import { type GlobalNavBarProps } from "./globalNavBar.type";

export const GlobalNavBar = ({ navigation }: GlobalNavBarProps) => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const { onNavigate } = useNewNavigate();
    const bookingURL = useBookingRecoilValue();

    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };

    return (
        <Wrapper columnGap="80px">
            <Flex columnGap="32px">
                {HEADER_GROUP.map((menu, index) => {
                    return (
                        <CustomBox key={menu.title}>
                            <CustomTitle p="0 12px" onMouseOver={() => setActiveIndex(index)}>
                                {menu.title}
                            </CustomTitle>
                            <CustomLocalNavBar
                                isExceedRoomAmountOfTen={
                                    navigation && navigation.roomList.length > 10 && menu.title === "Rooms"
                                }
                                onMouseLeave={() => setActiveIndex(null)}
                                className={activeIndex === index ? "on" : "off"}
                                flexDir="column"
                            >
                                {menu.title === "Specials" &&
                                    navigation?.specialList &&
                                    navigation.specialList.map((special) => (
                                        <CustomText
                                            onClick={() => onNavigate({ path: `specials/${special.special_idx}` })}
                                            key={special.special_idx}
                                            p="12px 0"
                                        >
                                            {special.special_name}
                                        </CustomText>
                                    ))}

                                {menu.title === "Rooms" &&
                                    navigation?.roomList &&
                                    navigation.roomList.map((room) => (
                                        <CustomText
                                            onClick={() => onNavigate({ path: `rooms/${room.room_idx}` })}
                                            key={room.room_idx}
                                            p="12px 0"
                                        >
                                            {room.room_name}
                                        </CustomText>
                                    ))}

                                {menu.title === "Reservation" &&
                                    menu.contents.map((content) => {
                                        return (
                                            <CustomText
                                                onClick={() => {
                                                    return onLink(bookingURL);
                                                }}
                                                key={content.title}
                                                p="12px 0"
                                            >
                                                {content.title}
                                            </CustomText>
                                        );
                                    })}

                                {menu.title !== "Reservation" &&
                                    menu.title !== "Rooms" &&
                                    menu.title !== "Specials" &&
                                    menu.contents.map((content) => {
                                        return (
                                            <CustomText
                                                onClick={() => onNavigate({ path: content.path })}
                                                key={content.title}
                                                p="12px 0"
                                            >
                                                {content.title}
                                            </CustomText>
                                        );
                                    })}
                            </CustomLocalNavBar>
                        </CustomBox>
                    );
                })}
            </Flex>
            <CustomButton iconNamed="notifications" size="medium" round="pill" onClick={() => onLink(bookingURL)}>
                실시간 예약
            </CustomButton>
        </Wrapper>
    );
};
